<app-stepper [numberOfSteps]="4" [currentStepIndex]="3"></app-stepper>
<app-data-validation
(updatedData)=updateData($event)>
</app-data-validation>
